import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Message, Menu } from 'semantic-ui-react';

class GroupList extends Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {

    let result = false;
    if(nextProps.GroupListFn.groupNum !== this.props.GroupListFn.groupNum) {
      result = true;
    }

    return result;
  }

  render() {

    const { sikdaeGroup, sikdaeGroupClick, groupNum } = this.props.GroupListFn;

    let buttonList = sikdaeGroup ?  sikdaeGroup.data.group.map((data, i) => {

      return (

        <Menu.Item
          name={data.name}
          active={data.idx === groupNum ? true : false}
          key={data.idx}
          onClick={(e) => {sikdaeGroupClick(data.idx, data.name)}}
        >
          {data.name}
        </Menu.Item>
      )
    }) : ""


    return(
      <div className="btnGroup">
        <Menu vertical className="vendysLeftMenu group" fluid>
          <Menu.Item className="top" name='title'>
            식대그룹
          </Menu.Item>
          {sikdaeGroup
          ? buttonList
          : ""
          }
        </Menu>
      </div>
    );
  }
}


export default GroupList;
